import {
  getContextLine,
  type MessagingJobRecord,
} from "./utils/messagingDateFormat";
import React from "react";

interface MessagingJobsProps {
  emailJobs: MessagingJobRecord[];
}

/**
 * Single-line messaging status for collapsed venue cards.
 * Shows: "{N sent · M scheduled} · Last messaged 3 days ago"
 * Or "No sent/scheduled messages found" when there are no jobs.
 */
export function MessagingStatusLine({ emailJobs }: MessagingJobsProps) {
  if (emailJobs.length === 0) {
    return (
      <p className="text-xs text-gray-400 whitespace-nowrap">
        No sent/scheduled messages
      </p>
    );
  }

  const contextLine = getContextLine(emailJobs);

  if (!contextLine) {
    return (
      <span className="text-xs text-gray-400 whitespace-nowrap">
        No sent/scheduled messages
      </span>
    );
  }

  return (
    <div className="flex items-center gap-2 text-xs min-w-0">
      <span
        className={`whitespace-nowrap ${
          contextLine.type === "scheduled" ? "text-blue-600" : "text-gray-500"
        }`}
      >
        {contextLine.text}
      </span>
    </div>
  );
}
